import { render } from "./NotificationsCounter.vue?vue&type=template&id=f5d32186&lang=pug"
import script from "./NotificationsCounter.vue?vue&type=script&lang=js"
export * from "./NotificationsCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__